module.exports = __webpack_public_path__ + "img/marketing.a8f845a9.svg";